package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.User
import br.com.heyagenda.domain.repository.AuthRepository
import kotlinx.coroutines.flow.StateFlow

class GetCurrentUserUseCase(
    private val authRepository: AuthRepository
) {
    operator fun invoke(): StateFlow<User?> {
        return authRepository.currentUser
    }
}
